const COGNITO_STORAGE_PREFIX = 'CognitoIdentityServiceProvider';

const storageHasCognitoSession = (storage?: Storage): boolean => {
  if (!storage) return false;

  for (let i = 0; i < storage.length; i += 1) {
    const key = storage.key(i);
    if (key?.startsWith(COGNITO_STORAGE_PREFIX)) return true;
  }

  return false;
};

const cookiesHaveCognitoSession = (): boolean => {
  if (typeof document === 'undefined') return false;
  return document.cookie.includes(COGNITO_STORAGE_PREFIX);
};

export const hasCachedCognitoSession = (): boolean => {
  if (typeof window === 'undefined') return false;

  return (
    storageHasCognitoSession(window.localStorage) ||
    storageHasCognitoSession(window.sessionStorage) ||
    cookiesHaveCognitoSession()
  );
};
